<div [class]="isBlock ? (preview ? 'box-block-preview' : 'box-block') : (preview ? 'box-preview' : 'box')">
  <div *ngIf="isBlock && !preview || !isBlock" class="simple-row" style="margin-top: -25px">
    <div class="wd-49-per">&nbsp;</div>
    <div *ngIf="!preview" style="display:flex;flex-flow:row">
      <button mat-mini-fab matTooltip="Add Question Before" (click)="performAction('before')"><mat-icon>add</mat-icon></button>
      <button *ngIf="isBlock" mat-mini-fab color="accent" matTooltip="Delete Block" (click)="deleteAction()"><mat-icon>delete</mat-icon></button>&nbsp;
    </div>
    <div class="wd-49-per">&nbsp;</div>
  </div>
  <ng-content></ng-content>
  <div *ngIf="isBlock && !preview || !isBlock" class="simple-row" style="margin-bottom: -25px">
    <div class="wd-49-per">&nbsp;</div>
    <div *ngIf="!preview" style="display:flex;flex-flow:row">
      <button mat-mini-fab matTooltip="Add Question After" (click)="performAction('after')"><mat-icon>add</mat-icon></button>
      <button *ngIf="isBlock" mat-mini-fab color="accent" matTooltip="Delete Block" (click)="deleteAction()"><mat-icon>delete</mat-icon></button>&nbsp;
    </div>
    <div class="wd-49-per">&nbsp;</div>
  </div>
</div>
